/**
 * Group the columns into the sections the will be rendered.
 */
export function groupColumns(columns) {
    return columns.reduce((acc, column) => {
        if (column.isSortRowColumn) {
            acc.sortRowColumn.push(column);
        }
        else if (column.isSelectRowColumn) {
            acc.selectRowColumn.push(column);
        }
        else if (column.isGrouped) {
            acc.groupedColumns.push(column);
        }
        else if (column.sticky) {
            if (column.stickyPosition === 'left') {
                acc.leftStickyColumns.push(column);
            }
            else {
                acc.rightStickyColumns.push(column);
            }
        }
        else {
            acc.generalColumns.push(column);
        }
        return acc;
    }, {
        sortRowColumn: [],
        selectRowColumn: [],
        groupedColumns: [],
        generalColumns: [],
        leftStickyColumns: [],
        rightStickyColumns: []
    });
}
export function groupCells(cells) {
    return cells.reduce((acc, cell) => {
        if (cell.column.isSortRowColumn) {
            acc.sortRowCells.push(cell);
        }
        else if (cell.column.isSelectRowColumn) {
            acc.selectRowCells.push(cell);
        }
        else if (cell.isGrouped || cell.isPlaceholder) {
            acc.groupedCells.push(cell);
        }
        else if (cell.column.sticky) {
            if (cell.column.stickyPosition === 'left') {
                acc.leftStickyCells.push(cell);
            }
            else {
                acc.rightStickyCells.push(cell);
            }
        }
        else {
            acc.generalCells.push(cell);
        }
        return acc;
    }, {
        sortRowCells: [],
        selectRowCells: [],
        groupedCells: [],
        generalCells: [],
        leftStickyCells: [],
        rightStickyCells: []
    });
}
//# sourceMappingURL=_grouping.js.map